import { render, staticRenderFns } from "./EnquiryV2DoctorDetailButton.vue?vue&type=template&id=159e8c87&scoped=true&"
import script from "./EnquiryV2DoctorDetailButton.vue?vue&type=script&lang=js&"
export * from "./EnquiryV2DoctorDetailButton.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryV2DoctorDetailButton.vue?vue&type=style&index=0&id=159e8c87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e8c87",
  null
  
)

export default component.exports